import { useState } from 'react';
import { TrashIcon, XMarkIcon } from '@heroicons/react/24/outline';

interface Props {
  selectedCount: number;
  onDelete: () => void;
  onCancel: () => void;
  isDeleting: boolean;
}

export default function BulkDeleteBar({ selectedCount, onDelete, onCancel, isDeleting }: Props) {
  const [confirming, setConfirming] = useState(false);

  const handleDelete = () => {
    if (!confirming) {
      setConfirming(true);
      return;
    }
    onDelete();
    setConfirming(false);
  };

  return (
    <div className="flex items-center justify-between bg-primary-500/15 border border-primary-500/50 rounded-lg px-4 py-2.5">
      <span className="text-sm text-primary-200">
        {selectedCount} item{selectedCount !== 1 ? 's' : ''} selected
      </span>
      <div className="flex items-center gap-2">
        {confirming && (
          <span className="text-sm text-red-400">Are you sure?</span>
        )}
        <button
          onClick={handleDelete}
          disabled={isDeleting}
          className="flex items-center gap-1.5 px-3 py-1.5 bg-red-600 hover:bg-red-500 disabled:opacity-50 text-white text-sm font-medium rounded-lg transition-colors"
        >
          <TrashIcon className="w-4 h-4" />
          {isDeleting ? 'Deleting…' : confirming ? 'Confirm Delete' : 'Delete Selected'}
        </button>
        <button
          onClick={() => { setConfirming(false); onCancel(); }}
          className="p-1.5 text-gray-400 hover:text-white transition-colors"
          title="Cancel selection"
        >
          <XMarkIcon className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
